import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { Loader2 } from "lucide-react";

export default function AuthCallback() {
  const nav = useNavigate();
  const location = useLocation();
  const { setUser } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const hash = location.hash || window.location.hash;
    const sid = new URLSearchParams(hash.replace("#", "")).get("session_id");
    if (!sid) { nav("/login"); return; }
    (async () => {
      try {
        const { data } = await api.post("/auth/google/session", { session_id: sid });
        window.history.replaceState(null, "", "/dashboard");
        setUser(data);
        nav("/dashboard", { state: { user: data } });
      } catch {
        nav("/login");
      }
    })();
  }, [location, nav, setUser]);

  return (
    <div className="min-h-screen bg-navy flex flex-col items-center justify-center text-white">
      <Loader2 className="w-10 h-10 animate-spin text-turquoise mb-4" />
      <p className="font-display font-bold">Opening the portal…</p>
    </div>
  );
}
